export default "__VITE_ASSET__lDMsWBrU__"